export namespace AuthenticationNs {

    export interface RouteFlagItemInterface {
        route: string,
        content: string,
        isVisible: boolean
    }

    export interface RouteFlagInterface {
        signIn: RouteFlagItemInterface,
        signUp: RouteFlagItemInterface,
        logout: RouteFlagItemInterface
    }

    export enum AuthenticationRouteEnums {
        Auth = 'Auth',
        SignIn = 'AuthSignIn',
        Social = 'AuthSocial',
        SignUp = 'AuthSignUp',
        Logout = 'AuthLogout',
        ForgotPassword = 'AuthForgotPassword',
        NewPassword = 'AuthNewPassword',
        ConfirmEmail = 'AuthConfirmEmail',
        RecoveryLink = 'AuthRecoveryLink',
        ExistingWorkspaces = 'AuthExistingWorkspaces',
        ExistingCreateWorkspaces = 'AuthExistingCreateWorkspaces',
        ConfirmDeleteWorkspace = 'AuthConfirmDeleteWorkspace',
        ConfirmDeleteAccount = 'AuthConfirmDeleteAccount'
    }

}

